import { Controller } from "stimulus"
import $ from 'jquery';
import Swal from 'sweetalert2';
export default class extends Controller {
  static values = {
    studyId: String,
    modalityId: String,
    childModalityId: String,
    readOnly: Boolean
  }
  static targets = ['form', 'childSelect', 'devices'];
  async connect() {
    const readOnly = this.readOnlyValue === true;
    this.element.querySelectorAll('.select2').forEach(select => {
      $(select).select2({ disabled: readOnly || select.disabled });

      if (readOnly) return;

      $(select).on('select2:select', (event) => {
        this.deviceAssignment(event);
      });

      $(select).on('select2:unselect', (event) => {
        this.deviceAssignment(event);
      });
    });
  }
  deviceAssignment(event) {
    if (this.readOnlyValue === true) return;
    event.preventDefault();
    const targetElement = event.currentTarget;
    const controller = this.application.getControllerForElementAndIdentifier(targetElement.closest('[data-controller="certify-modality"]'), 'certify-modality');
  
    if (!controller) return;
  
    let childModalityId;
    let studyId = controller.studyIdValue;
    let modalityId = controller.modalityIdValue;
  
    if (controller.hasChildSelectTarget && controller.childSelectTarget.value !== "") {
      childModalityId = controller.childSelectTarget.value;
    } else {
      childModalityId = controller.childModalityIdValue;
    }
  
    const selectedDeviceId = event.params.data.id;
    fetch(`/studies/${studyId}/certifiable_devices.json`, {
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
      },
      method: 'POST',
      body: JSON.stringify({
        child_modality_id: childModalityId,
        modality_id: modalityId,
        study_id: studyId,
        device_id: selectedDeviceId
      })
    });
  }
  
  initializeSelect2(element) {
    $(element)
      .select2()
      .on('select2:select', this.handleDeviceSelectChange.bind(this));
  }
  handleChildSelectChange() {
    if (this.readOnlyValue === true) return;
    const currentSelect = event.target;
    const currentValue = currentSelect.value;
  
    if (currentValue === "") return;
  
    const allChildSelects = document.querySelectorAll('.child-modality-select');
    let duplicateFound = false;
  
    allChildSelects.forEach((select) => {
      if (select !== currentSelect && select.value === currentValue) {
        duplicateFound = true;
      }
    });
  
    if (duplicateFound) {
      Swal.fire({
        icon: 'error',
        title: 'Duplication!',
        text: 'This Child Modality is Already Present.',
    });
    currentSelect.value = "";
    $(currentSelect).trigger('change.select2');
    return;
    }
  

    if (this.childSelectTarget.value != "") {
        this.populateChildSelect();
    }
  }
  populateChildSelect() {
    this.selectChangeUrl = document.location.origin + `/get_certified_devices.json`;
    const deviceId = this.data.get('deviceId');
    fetch(this.selectChangeUrl, {
        headers: {
            'Content-Type': 'application/json; charset=utf-8',
            'X-CSRF-Token': document.head.querySelector('meta[name="csrf-token"]').getAttribute('content')
        },
        
        method: 'POST',
        body: JSON.stringify({
            "child_modality_id": this.childSelectTarget.value
        })
    })
    .then(response => response.json())
    .then((data) => {
        const deviceselectBox = this.devicesTarget;
        deviceselectBox.innerHTML = ''; 
        // default text
        const devicesdefaultOption = document.createElement('option');
        devicesdefaultOption.value = "";
        devicesdefaultOption.selected = deviceId === "";
        deviceselectBox.appendChild(devicesdefaultOption);
        // loop through data 
        data["devices"].forEach((item, index) => {
            const opt = document.createElement('option');
            opt.value = item[0];
            opt.innerHTML = item[1];
            opt.selected = deviceId === item[0];
            deviceselectBox.appendChild(opt);
        }); 
        
    });
  }
  handleDeviceSelectChange(event) {
  }
}
window.initializeSelect2AndStimulus = function(element) {
  const select2s = element.querySelectorAll('.select2');
  select2s.forEach((el) => {
    $(el).select2();
  });

  const controller = element.closest('[data-controller]').__stimulusControllers[0];
  if (controller && controller.populateChildSelect) {
    controller.populateChildSelect.call(controller);
  }
};
